import React, { useState, useEffect } from "react";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import TopBar from "../../components/TopBar/TopBar";
import Footer from "../../components/footer/Footer";
import { DownloadSponsorReportPageStyle } from "./Configuration.style";
import { downloadReportvalidationSchema } from "../../validations/DownloadReportValidation";
import { TextErrorStyle3 } from "../../styles/ErrorStyles";
import { HeadingStyle, HeadingStyles2 } from "../../styles/HeadingStyles";
import { downloadSummaryReport } from "../../api/SponsorshipApi";
import { ThreeFieldRow } from "../../styles/HeadingStyles";

const DownloadSummaryReport = () => {
  const [email, setEmail] = useState("");
  const [usePreset, setUsePreset] = useState(true);
  const [preset, setPreset] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [schedule, setSchedule] = useState(false);
  const [instantmsg, setInstantmsg] = useState(true);
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("12:00");
  const [recurrence, setRecurrence] = useState("");
  const [errors, setErrors] = useState({});

  // fill start/end from preset…
  useEffect(() => {
    if (!usePreset) return;
    const today = new Date();
    let s = "", e = "";
    switch (preset) {
      case "Today":
        s = e = today; break;
      case "Yesterday":
        s = e = new Date(today.setDate(today.getDate() - 1)); break;
      case "Last 7 Days":
        e = today;
        s = new Date(today.setDate(today.getDate() - 6));
        break;
      case "Last 30 Days":
        e = today;
        s = new Date(today.setDate(today.getDate() - 29));
        break;
      case "Last 90 Days":
        e = today;
        s = new Date(today.setDate(today.getDate() - 89));
        break;
      case "Last 365 Days":
        e = today;
        s = new Date(today.setDate(today.getDate() - 364));
        break;
      default:
        s = e = "";
    }
    const fmt = d => d ? d.toISOString().slice(0, 10) : "";
    setStartDate(fmt(s));
    setEndDate(fmt(e));
  }, [preset, usePreset]);

  const handleValidate = async () => {
    try {
      await downloadReportvalidationSchema.validate(
        { email, startDate, endDate, schedule, scheduleDate, scheduleTime, recurrence },
        { abortEarly: false }
      );
      setErrors({});
      return true;
    } catch (err) {
      const ne = {};
      err.inner?.forEach(e => { ne[e.path] = e.message; });
      setErrors(ne);
      return false;
    }
  };

  const handleDownload = async () => {
    if (!(await handleValidate())) return;
    try {
      const blob = await downloadSummaryReport({
        email,
        isScheduled: schedule,
        startDate,
        endDate,
        scheduleDate,
        scheduleTime,
        recurrence,
        reportType: "summary"
      }, 'your-access-token-here');
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `SummaryReport_${new Date().toISOString().slice(0,10)}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download summary report:", error);
    }
  };

  return (
    <DownloadSponsorReportPageStyle>
      <TopBar authorized />
      <MainBodyStyle>
        <div className="configurationCard">
          <HeadingStyle>Download Dashboard Summary Report</HeadingStyle>
          <div style={{ marginTop: 50 }} />

          {/* Email */}
          <div className="headingStyle">
            <p className="heading_text">Email *:</p>
            <div className="input-div">
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Enter Email"
                className="form-control mt-1 input-field"
              />
              {errors.email && <TextErrorStyle3>{errors.email}</TextErrorStyle3>}
            </div>
          </div>

          {/* Preset toggle */}
          <div className="headingStyle">
            <p className="heading_text">Preset</p>
            <div className="radio-div2">
              <div className="form-check2">
                <input
                  type="radio"
                  name="dateMode"
                  className="form-check-input"
                  checked={usePreset}
                  onChange={() => setUsePreset(true)}
                />
                <label className="form-check-label">Yes</label>
              </div>
              <div className="form-check2">
                <input
                  type="radio"
                  name="dateMode"
                  className="form-check-input"
                  checked={!usePreset}
                  onChange={() => setUsePreset(false)}
                />
                <label className="form-check-label">No</label>
              </div>
            </div>
          </div>

          {/* Preset dropdown */}
          {usePreset && (
            <div className="headingStyle">
              <p className="heading_text">Preset:</p>
              <div className="input-div">
                <select
                  className="form-control mt-1 input-field"
                  value={preset}
                  onChange={e => setPreset(e.target.value)}
                >
                  <option value="" disabled>Select Preset</option>
                  {["Today","Yesterday","Last 7 Days","Last 30 Days","Last 90 Days","Last 365 Days"]
                    .map((p,i) => <option key={i} value={p}>{p}</option>)
                  }
                </select>
              </div>
            </div>
          )}

          {/* Manual date pickers */}
          {!usePreset && (
            <ThreeFieldRow>
              <div className="field">
                <p className="heading_text">Start Date *:</p>
                <input
                  type="date"
                  value={startDate}
                  max={new Date().toISOString().split("T")[0]}
                  onChange={e => setStartDate(e.target.value)}
                  className="form-control mt-1 input-field"
                />
                {errors.startDate && <TextErrorStyle3>{errors.startDate}</TextErrorStyle3>}
              </div>
              <div className="field">
                <p className="heading_text">End Date *:</p>
                <input
                  type="date"
                  value={endDate}
                  max={new Date().toISOString().split("T")[0]}
                  onChange={e => setEndDate(e.target.value)}
                  className="form-control mt-1 input-field"
                />
                {errors.endDate && <TextErrorStyle3>{errors.endDate}</TextErrorStyle3>}
              </div>
            </ThreeFieldRow>
          )}

          {/* Schedule toggle */}
          <div className="headingStyle">
            <p className="heading_text">Schedule Report:</p>
            <div className="radio-div2">
              <div className="form-check2">
                <input
                  type="radio"
                  className="form-check-input"
                  checked={schedule}
                  onChange={() => { setSchedule(true); setInstantmsg(false); }}
                />
                <label className="form-check-label">Yes</label>
              </div>
              <div className="form-check2">
                <input
                  type="radio"
                  className="form-check-input"
                  checked={instantmsg}
                  onChange={() => { setInstantmsg(true); setSchedule(false); }}
                />
                <label className="form-check-label">No</label>
              </div>
            </div>
          </div>

          {/* Schedule Date & Recurrence */}
         {schedule && (
  <ThreeFieldRow>
    <div className="field">
      <p className="heading_text">Schedule Date *:</p>
      <input
        type="date"
        value={scheduleDate}
        min={new Date().toISOString().split("T")[0]}
        onChange={e => setScheduleDate(e.target.value)}
        className="form-control mt-1 input-field"
      />
      {errors.scheduleDate && (
        <TextErrorStyle3>{errors.scheduleDate}</TextErrorStyle3>
      )}
    </div>

      <div className="field">
      <p className="heading_text">Schedule Time *:</p>
      <input
        type="time"
        value={scheduleTime}
        onChange={e => setScheduleTime(e.target.value)}
        className="form-control mt-1 input-field"
      />
      {errors.scheduleTime && (
        <TextErrorStyle3>{errors.scheduleTime}</TextErrorStyle3>
      )}
    </div>

    <div className="field">
      <p className="heading_text">Recurrence *:</p>
      <select
        value={recurrence}
        onChange={e => setRecurrence(e.target.value)}
        className="form-control mt-1 input-field"
      >
        <option value="Once">Once</option>
        <option value="Weekly">Weekly</option>
        <option value="Monthly">Monthly</option>
      </select>
      {errors.recurrence && (
        <TextErrorStyle3>{errors.recurrence}</TextErrorStyle3>
      )}
    </div>
  </ThreeFieldRow>
)}

          {/* Download button */}
          <div className="btn-div">
            <button className="btn form-button" onClick={handleDownload}>
              {schedule ? "Schedule" : "Download"}
            </button>
          </div>
        </div>
      </MainBodyStyle>
      <Footer style="footer" />
    </DownloadSponsorReportPageStyle>
  );
};

export default DownloadSummaryReport;
